import React, { useContext } from 'react';
import { createStyles } from 'utils/createStyle';
import { FamilyEnrollmentContext } from 'features/family-enrollment/context';
import { Btn } from 'components/btn/Btn';
import classnames from 'classnames';

export interface IBaseStyles {
    formContainer: string;
    buttonContainerStyles: string;
    buttonStyles: string;
    backButtonStyles: string;
}

interface ButtonControlsProps {
    nextLabel?: string;
    containerClassName?: string;
    nextButtonClassName?: string;
}

// NOTE: Update the interface when adding new base-styles
export const useBaseStyles = (): IBaseStyles => {
    return createStyles({
        formContainer: ['', { marginTop: 30 }],
        buttonContainerStyles: ['flex flex-col items-center gap-4 mb-8', { marginTop: 60 }],
        buttonStyles: 'w-fit px-[30px] py-[10px] text-[18px] leading-7',
        backButtonStyles: ['border-0 underline text-brand font-semibold text-lg'],
    });
};

export const ButtonControls = ({
    nextLabel = 'Next',
    containerClassName,
    nextButtonClassName,
}: ButtonControlsProps) => {
    const baseStyles = useBaseStyles();
    const { goToPreviousStep } = useContext(FamilyEnrollmentContext);

    return (
        <div className={classnames(baseStyles.buttonContainerStyles, containerClassName)}>
            <Btn className={classnames(baseStyles.buttonStyles, nextButtonClassName)} type="submit">
                {nextLabel}
            </Btn>
            <button
                className={classnames(baseStyles.buttonStyles, baseStyles.backButtonStyles)}
                onClick={(e) => {
                    e.preventDefault();
                    goToPreviousStep();
                }}
            >
                Back
            </button>
        </div>
    );
};
